import PageHero from "../components/PageHero";
import GalleryGrid from "../components/GalleryGrid";

export default function Cununie() {
  const IMAGINI = [1, 2, 3, 4, 5].map(n => `/images/cununie/${n}.png`);

  return (
    <section>
      <PageHero title="Rochii pentru cununie civilă" subtitle="Eleganță minimalistă, croieli moderne." />
      <GalleryGrid items={IMAGINI} />
    </section>
  );
}
